import { getApiBaseUrl } from './api';

/**
 * Socket.IO must use the same host:port as the REST API (not the React dev server origin).
 * Uses the same runtime base as axios (port-forward :9001, same-origin /api, etc.).
 */
export function getCameraSocketUrl() {
  const raw = String(getApiBaseUrl() || '').trim();
  const withoutApi = raw.replace(/\/?api\/?$/i, '').replace(/\/+$/, '');
  if (withoutApi) {
    try {
      const u = new URL(withoutApi.includes('://') ? withoutApi : `https://${withoutApi}`);
      return `${u.protocol}//${u.host}`;
    } catch {
      return withoutApi;
    }
  }
  if (typeof window !== 'undefined') {
    return window.location.origin;
  }
  return '';
}
